
import Dashboard from "views/pages/dashboards/Dashboard.jsx";
import LoginForm from "views/pages/auth/Login.jsx";
import Profile from "views/pages/auth/Profile.jsx";

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-shop text-primary",
    component: Dashboard,
    layout: "/admin"
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-shop text-primary",
    component: Dashboard,
    layout: "/superAdmin"
  },
  {
    collapse: true,
    name: "Authentication",
    icon: "ni ni-ungroup text-orange",
    state: "authenticationCollapse",
    views: [
      {
        path: "/login",
        name: "Login",
        component: LoginForm,
        layout: "/auth"
      },
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
        layout: "/admin"
      }
    ]
  }
];

export default routes;
